import { createFileRoute } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { useDocumentDetail } from '@/api/document/use-document-detail';
import Loader from '@/components/molecules/loader';
import { DocumentType } from '@repo/database/browser';
import { PROTECTED, FORECAST } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/document/$id'
)({
  component: DocumentModal,
});

function DocumentModal() {
  const { id } = Route.useParams();
  const { data: document, isLoading } = useDocumentDetail(id);

  if (isLoading) {
    return <Loader showLoader />;
  }

  const subTab =
    document?.type === DocumentType.PAYROLL ? 'payroll' : undefined;
  return (
    <DocumentForm
      id={id}
      subTab={subTab}
      returnUrl={`${PROTECTED}${FORECAST}`}
    />
  );
}
